import React from 'react';

import useClassy from '@core/hooks/useClassy';

import classes from './style.module.scss';
import './style.scss';

interface SidebarHeaderProps {
  children?: React.ReactNode;
}

const SidebarHeader = ({ children }: SidebarHeaderProps) => {
  const bem = useClassy(classes, 'Nav');

  return <div className={bem('-header', 'rm-Nav-header')}>{children}</div>;
};

export default SidebarHeader;
